import React from 'react';
import { defineMessage, FormattedMessage, useIntl } from 'react-intl';

import TrackingNumber from './component';

const trackingNumber = defineMessage({
  description: 'markAsShipped.columns.trackingNumber',
  defaultMessage: 'Tracking Number',
  id: 'IRFtsu',
});

const GetName = () => {
  const intl = useIntl();

  return intl.formatMessage(trackingNumber);
};

export default {
  id: 'mark-as-shipped-tracking-number',
  index: 4,
  isDragable: false,
  minWidth: 100,
  width: 200,
  nonsortable: true,
  getName: GetName,
  name: <FormattedMessage {...trackingNumber} />,
  render: (data) => {
    return <TrackingNumber fulfillmentPlanId={data.id} />;
  },
};
